const money = (v) => {
  const n = Number(v || 0);
  return `${n < 0 ? "-" : ""}₹${Math.abs(n).toFixed(2)}`;
};

/**
 * Read-only payhead breakdown, grouped by section - the same grouping
 * shown on the Wage Rate and Payroll Template screens (Standard Monthly
 * Salary / Extra Earnings / Employer Deduction / Employee Deduction), so
 * a generated/previewed payslip reads consistently with where its
 * numbers came from.
 *
 * payheads: the array returned by the backend's computeGrossPay - each
 * item already carries section_name (see
 * Kasturi-Node-Backend/Services/payroll/payrollCalculation.service.js).
 */
const PayheadBreakdownView = ({ payheads, title = "Salary Components" }) => {
  if (!payheads?.length) return null;

  const sections = [...new Set(payheads.map((p) => p.section_name || "Other"))];

  return (
    <div className="mb-3">
      <div className="fw-semibold mb-1" style={{ fontSize: "12px" }}>
        {title}
      </div>

      {sections.map((section) => {
        const sectionPayheads = payheads.filter((p) => (p.section_name || "Other") === section);
        const sectionTotal = sectionPayheads.reduce((sum, p) => sum + Number(p.prorated_amount || 0), 0);

        return (
          <div className="card border mb-2" key={section}>
            <div className="card-header bg-light py-1" style={{ fontWeight: 600, fontSize: "12px" }}>
              {section}
            </div>
            <table className="table table-sm mb-0">
              <thead>
                <tr style={{ fontSize: "11px" }} className="text-muted">
                  <th>Component</th>
                  <th className="text-end">Rate (₹)</th>
                  <th className="text-end">Pro-rated (₹)</th>
                </tr>
              </thead>
              <tbody>
                {sectionPayheads.map((p, i) => (
                  <tr key={i} style={{ fontSize: "13px" }} className={Number(p.prorated_amount) < 0 ? "text-danger" : ""}>
                    <td>{p.category_name}</td>
                    <td className="text-end">{money(p.amount)}</td>
                    <td className="text-end">{money(p.prorated_amount)}</td>
                  </tr>
                ))}
                <tr className={`fw-semibold ${sectionTotal < 0 ? "text-danger" : ""}`} style={{ fontSize: "13px" }}>
                  <td colSpan={2}>Subtotal - {section}</td>
                  <td className="text-end">{money(sectionTotal)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
};

export default PayheadBreakdownView;
